<template>

  <nav class="competition-tabs">

    <button
        v-for="tab in tabs"
        :key="tab.value"
        @click="$emit('input', tab.value)"
        :class="{ active: value === tab.value }"
    >

      {{ tab.label }}

    </button>

  </nav>

</template>

<script>

export default {

  name: 'CompetitionTabs',

  props: {

    value: {

      type: String,

      default: 'table'

    }

  },

  data() {

    return {

      tabs: [

        {
          value: 'table',
          label: 'جدول'
        },

        {
          value: 'matches',
          label: 'مسابقات'
        },

        {
          value: 'news',
          label: 'اخبار'
        },

        {
          value: 'stats',
          label: 'آمار'
        }

      ]

    }

  }

}

</script>

<style scoped>

.competition-tabs{

  display:flex;

  gap:12px;

  margin-bottom:24px;

  overflow-x:auto;

  scrollbar-width:none;

}

.competition-tabs::-webkit-scrollbar{

  display:none;

}

button{

  flex:0 0 auto;

  border:none;

  background:#f1f5f9;

  color:#334155;

  padding:12px 22px;

  border-radius:14px;

  cursor:pointer;

  font-size:14px;

  font-weight:600;

  transition:.25s;

  white-space:nowrap;

}

button:hover{

  background:#eef9f3;

}

button.active{

  background:#047857;

  color:#fff;

}

button.active:hover{

  background:#065f46;

}

/* =========================
   MOBILE — سگمنت‌کنترل بدون اسکرول افقی
   به‌جای ردیف قابل اسکرول، چهار تب هم‌عرض
   داخل یک ریل خاکستری که کل عرض را پر می‌کند
   ========================= */
@media (max-width: 768px) {

  .competition-tabs{

    display:grid;

    grid-auto-flow:column;

    grid-auto-columns:1fr;

    gap:4px;

    margin-bottom:14px;

    padding:4px;

    background:#f1f5f9;

    border-radius:13px;

    overflow:visible;

  }

  button{

    flex:initial;

    padding:9px 2px;

    border-radius:10px;

    font-size:12.5px;

    text-align:center;

    white-space:nowrap;

    background:transparent;

    color:#64748b;

  }

  button:hover{

    background:transparent;

    color:#0f172a;

  }

  button.active{

    background:#fff;

    color:#047857;

    box-shadow:0 1px 4px rgba(15,23,42,.14);

  }

  button.active:hover{

    background:#fff;

  }

}

</style>